exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.statistics-member .bd-box[data-v-6f57b6b5]{ border-top: 1px solid #EEEEEE;\n}\n.statistics-member .left-box[data-v-6f57b6b5]{ width: 100%;\n}\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_supplier/src/views/statistics/user/index.vue"],"names":[],"mappings":";AACA,6CAA6C,8BAA8B;CAC1E;AACD,+CAA+C,YAAY;CAC1D","file":"index.vue","sourcesContent":["\n.statistics-member .bd-box[data-v-6f57b6b5]{ border-top: 1px solid #EEEEEE;\n}\n.statistics-member .left-box[data-v-6f57b6b5]{ width: 100%;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6f57b6b5","scoped":true,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/statistics/user/index.vue
// module id = N6pK
// module chunks = 0